<template>
    <div>
        <el-popover
            placement="bottom-end"
            title="字段配置"
            trigger="click"
            v-model="popoverIsShow"
            class="drag-container">
            <div style="width: 510px;" ref="wrap">
                <div v-for="(item, index) in currentTableFields"
                    :key="item.prop"
                    class="checkBoxesBlock"
                    style="display: inline-block;width: 170px;">
                    <el-checkbox :disabled="item.fieldIsDisabled"
                                v-model="item.fieldIsShow">{{getIndex(index)}} {{item.label}}</el-checkbox>
                </div>
            </div>
            <div style="display: flex;justify-content: flex-end;">
                <el-button size="medium"
                        style="width: 80px"
                        @click="close">取消</el-button>
                <el-button type="primary"
                        size="medium"
                        style="width: 80px"
                        @click="splitFields">确定</el-button>
            </div>
            <i class="el-icon-s-operation" slot="reference"/>
        </el-popover>
    </div>
</template>

<script>
    import Sortable from 'sortablejs';

    export default {
        name: 'TableFilterPopover',
        props: {
            tableKey: {
                type: Number,
                default: 0,
            },
            tableSplitFields: {
                type: Array,
                default: () => [],
            },
            tableItems: {
                type: Array,
                default: () => [],
            },
            tabsActiveName: {
                type: String,
                default: '',
            },
            tableName: {
                type: String,
                default: '',
            }
        },
        data() {
            return {
                popoverIsShow: false,
                currentTableFields: [],
                localStorageTableFields: [],
                tsTableFieldsObj: {},
                originalTableFields: []
            }
        },
        computed: {
            systemName() {
                return this.$store.getters.name
            },
            systemVersion() {
                return this.$store.getters.version
            }
        },
        // 获取本地缓存列筛选数据
        created() {
            this.tsTableFieldsObj = JSON.parse(localStorage.getItem('tsTableFieldsObj')) || {};
            if (!this.tsTableFieldsObj[this.systemName]) {
                this.tsTableFieldsObj[this.systemName] = {};
                this.tsTableFieldsObj[this.systemName]['version'] = this.systemVersion;
            }
            // if (this.tsTableFieldsObj && this.tsTableFieldsObj[this.systemName] && this.tsTableFieldsObj[this.systemName][this.tableName]) {
            //     if (this.tabsActiveName !== '') {
            //         this.localStorageTableFields = this.tsTableFieldsObj[this.systemName][this.tableName][this.tabsActiveName];
            //     } else {
            //         this.localStorageTableFields = this.tsTableFieldsObj[this.systemName][this.tableName]['0'];
            //     }
            //     // this.localStorageTableFieldsCheck();
            // }
        },
        watch: {
            popoverIsShow() {
                if (this.popoverIsShow) {
                    this.currentTableFields = JSON.parse(JSON.stringify(this.tableSplitFields));
                    this.originalTableFields = JSON.parse(JSON.stringify(this.currentTableFields));
                    this.createSortable();
                }
            },
            // 切换tabs时，获取当前tabs下的列筛选数据
            tabsActiveName() {
                if (this.tsTableFieldsObj[this.systemName][this.tableName] && this.tsTableFieldsObj[this.systemName][this.tableName][this.tabsActiveName]) {
                    this.currentTableFields = this.tsTableFieldsObj[this.systemName][this.tableName][this.tabsActiveName];
                } else {
                    this.currentTableFields = JSON.parse(JSON.stringify(this.tableItems.map(item => ({
                        ...item,
                        fieldIsShow: item.fieldIsShow !== undefined ? item.fieldIsShow : true,
                        fieldIsDisabled: item.fieldIsDisabled !== undefined ? item.fieldIsDisabled : false
                    }))));
                }
                this.$emit('update:tableSplitFields', this.currentTableFields);
                this.$emit('update:tableKey', this.tableKey + 1);
            },
            // 父组件列筛选数据变化时，获取当前表格列筛选数据
            tableSplitFields: {
                handler() {
                    // if (this.localStorageTableFields.length > 0) {
                    //     // 获取本地缓存列筛选数据且仅第一次
                    //     this.currentTableFields = JSON.parse(JSON.stringify(this.localStorageTableFields));
                    //     this.localStorageTableFields = [];
                    //     this.$emit('update:tableSplitFields', this.currentTableFields);
                    // } else {
                    //     // 本地缓存无列筛选数据
                    //     this.currentTableFields = JSON.parse(JSON.stringify(this.tableSplitFields));
                    // }
                    this.currentTableFields = JSON.parse(JSON.stringify(this.tableSplitFields));
                }
            }
        },
        methods: {
            getIndex(index) {
                if (index < 9) {
                    return `0${(index + 1).toString()}`;
                }
                return (index + 1).toString();
            },
            createSortable() {
                const el = this.$refs.wrap;
                new Sortable(el, {
                    animation: 150,
                    handle: ".checkBoxesBlock",
                    draggable: ".checkBoxesBlock",
                    dragClass: "sortable-drag",
                    onEnd: evt => {
                        let {newIndex, oldIndex} = evt;
                        if (newIndex === oldIndex) return;
                        const _copy = [...this.currentTableFields];
                        const [item] = _copy.splice(oldIndex, 1)
                        _copy.splice(newIndex, 0, item)
                        this.currentTableFields.splice(0);
                        this.$nextTick(() => {
                            this.currentTableFields.push(..._copy);

                        })
                    }
                });
            },
            localStorageTableFieldsCheck() {
                let localArr = JSON.parse(JSON.stringify(this.localStorageTableFields || []));
                let newArr = JSON.parse(JSON.stringify(this.tableItems));
                let result = [];
                newArr.forEach(item => {
                    let j = localArr.findIndex(i => i.prop === item.prop && i.label === item.label);
                    if (j === -1) {
                        result.push(item);
                    } else {
                        result.push({
                            ...item,
                            fieldIsDisabled: localArr[j].fieldIsDisabled,
                            fieldIsShow: localArr[j].fieldIsShow
                        });
                    }
                });
                this.localStorageTableFields = result;
                if (this.tabsActiveName !== '') {
                    this.tsTableFieldsObj[this.systemName][this.tableName][this.tabsActiveName] = result;
                } else {
                    this.tsTableFieldsObj[this.systemName][this.tableName]['0'] = result;
                }
                localStorage.setItem('tsTableFieldsObj', JSON.stringify(this.tsTableFieldsObj));
            },
            // 完成列筛选
            splitFields() {
                const arr = JSON.parse(JSON.stringify(this.currentTableFields))
                this.currentTableFields.forEach(item => {
                    if (item.fieldIsDisabled && item.followFieldIsShow) {
                        const i = arr.findIndex(e => e.param === item.followFieldIsShow);
                        if (i !== -1) {
                            item.fieldIsShow = arr[i].fieldIsShow;
                        }
                    }
                });
                this.originalTableFields.splice(0);
                this.originalTableFields.push(...this.currentTableFields);
                if (this.tabsActiveName === '') {
                    this.tsTableFieldsObj[this.systemName][this.tableName] = {};
                    this.tsTableFieldsObj[this.systemName][this.tableName]['0'] = this.currentTableFields;
                } else {
                    if (this.tsTableFieldsObj[this.systemName][this.tableName] === undefined) {
                        this.tsTableFieldsObj[this.systemName][this.tableName] = {};
                    }
                    this.tsTableFieldsObj[this.systemName][this.tableName][this.tabsActiveName] = this.currentTableFields;
                }
                localStorage.setItem('tsTableFieldsObj', JSON.stringify(this.tsTableFieldsObj));
                this.$emit('update:tableSplitFields', this.currentTableFields);
                this.$emit('update:tableKey', this.tableKey + 1);
                this.close();
            },
            close() {
                this.popoverIsShow = false;
                this.currentTableFields.splice(0);
                this.currentTableFields.push(...this.originalTableFields);
            }
        }
    }
</script>

<style>
    .el-icon-s-operation {
        font-size: 30px;
        margin: 10px;
        float: right;
    }
    .checkBoxesBlock {
        display: block;
        margin: 5px 0;
        cursor: pointer;
    }
</style>